module.exports = __webpack_public_path__ + "img/clientlogin.5b5362ec.png";